import { Injectable } from '@angular/core';
import { DsconfigService, RestConnService } from '@services/services.module';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ContactsService {
  private contactData: object;
  private contactDelete: object;
  private contact: object;
  private listContact: object;

  constructor(
    private dsConfig: DsconfigService,
    private _res: RestConnService,
    public translate: TranslateService
  ) {
    this.contactData = {
      'contactData': dsConfig.getUrlBase() + '/ess/v1/contact/client'
    };
    this.listContact = {
      'list_contact': dsConfig.getUrlBase() + '/ess/v1/contact/all'
    };
  }

  updateContact(data: any): Observable<any> {
    this.contact = {
      'contact': this.dsConfig.getUrlBase() + '/ess/v1/contact'
    };
    if (data.contactId !== null) {
      return this._res
        .put('contact', data,
          {
            collection: this.contact
          });
    } else {
      return this._res
        .post('contact', data,
          {
            collection: this.contact
          });
    }
  }

  deleteContact(data: any): Observable<any> {
    this.contactDelete = {
      'contactDelete': this.dsConfig.getUrlBase() + '/ess/v1/contact/contact'
    };
    if (data.contactId !== null) {
      return this._res
        .post('contactDelete',  data,
          {
            collection: this.contactDelete
          });
    }
  }

  getAllContacts(): Observable<any> {
    return this._res.get('listContact', {},
      {
        collection: this.listContact
      }
    );
  }

  getContactData(clientId): Observable<any> {
    return this._res.get('contactData', { intCliId: clientId },
      {
        collection: this.contactData
      }
    );
  }
}
